<template>
 <div class="wrapper">
    <div class="header container">
      
        <div class="header-left">
           <img src='../../assets/img/head-logo.jpg' class="head-logo"/>
        </div>
        <div class="header-right">
            <div :class="[currentPage=='home'?'active-nav':'']" @click="goView('home')">首页</div>
            <div :class="[currentPage=='service'?'active-nav':'']" @click="goView('service')">服务</div>
            <div :class="[currentPage=='us'?'active-nav':'']" @click="goView('aboutUs')">我们</div>
            <div :class="[currentPage=='hz'?'active-nav':'']" @click="goView('cooperation')">合作</div>
        </div>
         
    </div>
     </div>
</template>

<script>
    export default {
        name:"Header",
        data(){
            return {
               
            }
        },
       props:{
           currentPage:String
       },
        created(){
           
        },
        methods:{
             goView(path){
                 this.$router.push(path);
             }
        }
    }
</script>
<style scoped>
.wrapper{
     background: #fff;
}
.header{
    display: flex;
    height: 60px;
    padding:15px 40px;
    align-items: center;
    justify-content: space-between;
}
.head-logo{
   width:148px ;
   height: 30px;
   object-fit: contain;
}
.active-nav{
    color:#1EBDF5;
}
.header-right{
    display: flex;
    align-items: center;
    /* font-size: 12px; */
}
.header-right div{
    margin-left:52px;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue